// For DS styled Links please see import { DefaultLink, NavLink, Link, FakeLink } from '@hivebrite/design-system/Link';

import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import {
  Link as ReactLink,
  NavLink as ReactNavLink,
  useLocation,
} from 'react-router-dom';

const DefaultLink = forwardRef(
  ({ children, target, rel: initialRel, active, ...otherProps }, ref) => {
    const initialRelProps = initialRel ? ` ${initialRel}` : '';
    const isTargetBlank = target === '_blank';
    const rel = isTargetBlank
      ? `noopener noreferrer${initialRelProps}`
      : initialRel;

    return (
      <a {...otherProps} target={target} rel={rel} ref={ref}>
        {children}
      </a>
    );
  },
);

const DynamicLink = ({
  forceDefaultLink,
  type,
  to,
  children,
  ...linkAttrs
}) => {
  let Component = null;
  let insideReactRouter;

  try {
    useLocation();
    insideReactRouter = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    insideReactRouter = false;
  }

  if (insideReactRouter && !forceDefaultLink) {
    linkAttrs.to = to;

    switch (type) {
      case 'Link': {
        linkAttrs['data-testid'] = 'react-link-element';
        Component = ReactLink;
        break;
      }

      case 'NavLink': {
        linkAttrs['data-testid'] = 'react-navlink-element';
        Component = ReactNavLink;
        break;
      }

      default:
    }
  } else {
    linkAttrs.href = to;
    linkAttrs['data-testid'] = 'default-link-element';

    Component = DefaultLink;
  }

  return <Component {...linkAttrs}>{children}</Component>;
};

DynamicLink.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  forceDefaultLink: PropTypes.bool,
  target: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

DynamicLink.defaultProps = {
  disabled: false,
  forceDefaultLink: false,
};

const Link = (props) => <DynamicLink type="Link" {...props} />;
const NavLink = (props) => <DynamicLink type="NavLink" {...props} />;

export {
  Link, // react-router classic Link, should be primary used. Fallback to DefaultLink if no react-router wrapper (on PO for ex.)
  DefaultLink, // classic <a> tag, should be used only when routing is not necessary
  NavLink, // react-router classic NavLink
};
